var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2802 6.92999H6.72471C5.95251 6.92999 5.32715 7.56051 5.32715 8.33271V30.3717C5.32715 31.1439 5.95228 31.7692 6.72471 31.7692H37.2802C38.0524 31.7692 38.6829 31.1441 38.6829 30.3717V8.33271C38.6829 7.56051 38.0524 6.92999 37.2802 6.92999ZM22.0021 30.6246C21.4558 30.6246 21.0143 30.178 21.0143 29.6317C21.0143 29.08 21.4556 28.6333 22.0021 28.6333C22.5539 28.6333 22.9951 29.0799 22.9951 29.6317C22.9951 30.178 22.5539 30.6246 22.0021 30.6246ZM36.2349 27.7823H7.77003V9.37834H36.2349V27.7823Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57715 22.649H33.7809V25.9431H9.57715V22.649Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6626 12.8822C11.6626 11.5846 12.7187 10.534 14.0109 10.534C15.3086 10.534 16.3646 11.5846 16.3646 12.8822C16.3646 14.1747 15.3085 15.2305 14.0109 15.2305C12.7186 15.2305 11.6626 14.1747 11.6626 12.8822Z",
    fill: "#616161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4555 20.8632H9.57129V18.893C9.57129 17.0542 11.0685 15.5621 12.9128 15.5621H13.0756L13.1649 15.704L14.0108 17.3589L14.9301 15.5621H15.0877C16.958 15.5621 18.4555 17.0542 18.4555 18.893L18.4555 20.8632Z",
    fill: "#616161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6547 34.3121V37.0968H16.3486V34.3121H18.6866V32.2948H25.3218V34.3121H27.6547Z",
    fill: "#616161"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0146 13.4134H33.5188V13.9388H21.0146V13.4134Z",
    fill: "#616161"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0146 17.7581H33.5188V18.2835H21.0146V17.7581Z",
    fill: "#616161"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0146 19.9279H33.5188V20.4534H21.0146V19.9279Z",
    fill: "#616161"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0146 11.2436H33.5188V11.769H21.0146V11.2436Z",
    fill: "#616161"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0146 15.5832H33.5188V16.1087H21.0146V15.5832Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserConfig);
export default __webpack_public_path__ + "static/media/UserConfig.8bdd7a794e9c7ffc476929d016ff70da.svg";
export { ForwardRef as ReactComponent };